import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-malone-group-logo',
	template: `
    <!-- <img 	routerLink="/"
			src="https://storagemalone.blob.core.windows.net/website/assets/logo-trans2.png"
			title="Prism Image"
			[ngStyle]="customStyles"
			[ngClass]="customClass"
			[attr.x-contenttype]="'image/png'"> -->
	<img 	routerLink="/"
			src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/Malone-Group-Logo-B.png"
			title="Prism Image"
			[ngStyle]="customStyles"
			[ngClass]="customClass"
			[attr.x-contenttype]="'image/png'">
  	`,
	styles: [`
		.app-HeaderImage {
			padding: 0.2em;
			max-height: 3em;
		}
	`]
})
export class MaloneGroupLogoComponent {
	@Input() customStyles: { [key: string]: string } = {};
	@Input() customClass: string | string[] | Set<string> | { [klass: string]: any } = '';
}
